/* REALSTIL FIT v9 – Größenberater als Chat.
 * Rechnet lokal im Browser mit den Produktmaßen der Hersteller-Maßtabellen (Printegy / Stanley/Stella / B&C).
 * Kein Server. Körpermaße werden aus Größe + Gewicht geschätzt oder direkt eingegeben und mit den
 * flach gemessenen Artikelmaßen inkl. schnittabhängiger Bewegungsweite verglichen.
 */
(function () {
  'use strict';
  if (window.__rsFitV9) { window.__rsFitV9.init(); return; }

  var STORE_KEY = 'rsFitProfileV9';

  /* ---------- Produktmaße (cm, flach = halbe Weite, außer Körpermaßtabellen) ---------- */
  var CHARTS = {
    'oversize-t-shirt': {
      group: 'top', cut: 'oversized', src: 'Printegy Oversize T-Shirt (BY102)', tol: 1,
      sizes: ['S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'],
      chest: [57, 60, 63, 66, 69, 73.5, 78, 82.5], length: [76, 78, 80, 82, 84, 85, 86, 87],
      sleeve: [21, 22, 23, 24, 25, 25.5, 26, 26.5], hem: [55, 58, 61, 64, 67, 71.5, 76, 80.5],
      ease: [15, 20, 26], lenRatio: 0.44
    },
    'washed-t-shirt': {
      group: 'top', cut: 'oversized', src: 'Printegy Oversize Washed T-Shirt (BY189)', tol: 1,
      sizes: ['S', 'M', 'L', 'XL', 'XXL'],
      chest: [57, 60, 63, 66, 69], length: [76, 78, 80, 82, 84],
      ease: [15, 20, 26], lenRatio: 0.44
    },
    'oversize-hoodie': {
      group: 'top', cut: 'oversized', src: 'Printegy Oversize Hoodie ohne Kordel', tol: 1,
      sizes: ['S', 'M', 'L', 'XL', 'XXL', '3XL'],
      chest: [58, 61, 64, 67, 70, 74.5], length: [72, 73, 75, 77, 79, 80],
      hem: [48, 51, 54, 57, 60, 64.5], sleeve: [63.6, 64, 64.4, 64.8, 65.2, 65.6],
      ease: [16, 21, 27], lenRatio: 0.415
    },
    'zipper-hoodie': {
      group: 'top', cut: 'oversized', src: 'Printegy Herren Oversize Zipper Hoodie', tol: 1,
      sizes: ['S', 'M', 'L', 'XL', 'XXL'],
      chest: [58, 61, 64, 67, 70], length: [68, 69, 71, 73, 75], sleeve: [60.6, 61, 61.4, 61.8, 62.2],
      ease: [16, 21, 27], lenRatio: 0.395
    },
    'zip-longsleeve': {
      group: 'top', cut: 'regular', src: 'REALSTIL-Maßtabelle', tol: 1,
      sizes: ['S', 'M', 'L', 'XL'],
      chest: [51, 53, 56, 59], length: [71, 72, 73, 74],
      ease: [5, 9, 14], lenRatio: 0.405
    },
    'windbreaker': {
      group: 'top', cut: 'relaxed', src: 'REALSTIL-Maßtabelle', tol: 1,
      sizes: ['S', 'M', 'L', 'XL'],
      chest: [57, 60.5, 64, 67.5], length: [68, 70, 72, 74],
      ease: [14, 20, 26], lenRatio: 0.40
    },
    'regular-fit-t-shirt': {
      group: 'top', cut: 'regular', src: 'Stanley/Stella Creator', tol: 1,
      sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'],
      chest: [45.5, 47.5, 49.5, 53.5, 56.5, 59.5, 63.5, 67.5, 72.5, 77.5],
      length: [62, 65, 69, 73, 75, 77, 79, 81, 83, 84], sleeve: [20, 21, 22.5, 24, 24.5, 25, 25.5, 26, 26, 26],
      ease: [5, 9, 14], lenRatio: 0.41
    },
    'steppjacke': {
      group: 'jacket', cut: 'body', src: 'REALSTIL-Maßtabelle (Körpermaße)',
      sizes: ['S', 'M', 'L', 'XL'],
      bodyChest: [[90, 96], [96, 102], [102, 106], [106, 112]], bodyWaist: [[74, 80], [80, 86], [86, 91], [91, 96]]
    },
    'jogger': {
      group: 'bottom', cut: 'oversized', src: 'Printegy Oversize Fluffy Sweatpants', tol: 1,
      sizes: ['S', 'M', 'L', 'XL', 'XXL'],
      waist: [32.5, 35, 37.5, 40, 43], hip: [55.5, 58, 60.5, 63, 66], inseam: [75, 75, 76.5, 78, 78], hem: [23.5, 24, 24.5, 25, 25.6],
      ease: [8, 13, 18]
    },
    'jogger-loose-fit': {
      group: 'bottom', cut: 'loose', src: 'Printegy Oversize Sweatpants', tol: 2,
      sizes: ['S', 'M', 'L', 'XL', 'XXL'],
      waist: [28, 32, 35.5, 38, 42], inseam: [79.5, 80.5, 81.5, 82.5, 82.5], outseam: [106, 108, 110, 112, 113],
      ease: [-24, -18, -12]
    },
    'kids': {
      group: 'kids', src: 'B&C Kids (TK002)',
      sizes: ['3/4', '5/6', '7/8', '9/11', '12/14'],
      height: [[98, 104], [110, 116], [122, 128], [134, 146], [152, 161]],
      chest: [30, 33, 36, 39.5, 43], length: [45, 48, 51, 54.5, 58]
    },
    'baby-body': {
      group: 'baby', src: 'B&C Baby Bodysuit (BZ30)',
      sizes: ['0/3', '3/6', '6/12', '12/18'],
      months: [[0, 3], [3, 6], [6, 12], [12, 18]],
      chest: [20, 22, 24, 25.5], sleeve: [20, 21.5, 23.5, 25.5]
    },
    'bucket-hat': {
      group: 'hat', src: 'Printegy Bucket Hat',
      sizes: ['S/M', 'L/XL'], head: [58, 60]
    }
  };
  var KIND_NAMES = {
    'oversize-t-shirt': 'Oversized T-Shirt', 'washed-t-shirt': 'Washed Oversized T-Shirt', 'oversize-hoodie': 'Oversized Hoodie',
    'zipper-hoodie': 'Oversized Zipper Hoodie', 'zip-longsleeve': 'Zip Longsleeve', 'windbreaker': 'Windbreaker',
    'regular-fit-t-shirt': 'Regular Fit T-Shirt', 'steppjacke': 'Steppjacke', 'jogger': 'Jogger', 'jogger-loose-fit': 'Jogger Loose Fit',
    'kids': 'Kids T-Shirt', 'baby-body': 'Babybody', 'bucket-hat': 'Bucket Hat'
  };
  var KIND_ORDER = ['oversize-t-shirt', 'washed-t-shirt', 'oversize-hoodie', 'zipper-hoodie', 'jogger', 'jogger-loose-fit', 'regular-fit-t-shirt', 'zip-longsleeve', 'windbreaker', 'steppjacke', 'kids', 'baby-body', 'bucket-hat'];
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];

  /* ---------- Texte ---------- */
  var T = {
    de: {
      hiProduct: 'Hi! Ich finde deine Größe für „{name}“ – mit den echten Maßen dieses Artikels. Wie groß und wie schwer bist du?',
      hiPage: 'Hi! Ich finde deine Größe anhand der echten Produktmaße. Für welches Teil suchst du?',
      askBody: 'Wie groß und wie schwer bist du? Zum Beispiel „183 cm, 86 kg“.',
      askBodyShort: 'Mir fehlt noch {what}.', heightWord: 'deine Körpergröße', weightWord: 'dein Gewicht',
      back: 'Willkommen zurück. Ich habe noch deine Angaben: {summary}. Soll ich damit für „{name}“ rechnen?',
      hiShort: 'Hi! Ich finde die passende Größe für „{name}“.',
      backYes: 'Ja, damit rechnen', backNo: 'Neu eingeben',
      gotBody: '{h} cm und {w} kg, danke.', askFit: 'Wie soll es sitzen?',
      fitO: ['Weniger oversized', 'Oversized wie gedacht', 'Extra weit'], fitR: ['Körpernah', 'Normal', 'Locker'],
      askKids: 'Wie groß ist das Kind aktuell? Bitte in cm.', askBaby: 'Wie alt ist das Baby? Bitte in Monaten.', askHead: 'Wie groß ist dein Kopfumfang in cm? Maßband über Stirn und Hinterkopf legen.',
      askChest: 'Miss locker unter den Achseln um die breiteste Stelle der Brust. Wie viele cm?',
      askHip: 'Miss um die breiteste Stelle der Hüfte. Wie viele cm?',
      askUsual: 'Welche Größe trägst du normalerweise, zum Beispiel bei T-Shirts anderer Marken?',
      onlyUsual: 'Ich kenne nur meine übliche Größe',
      rec: 'Meine Empfehlung: {size}.', recSame: 'Es bleibt bei {size}.', recNew: 'Jetzt {size} statt {old}.',
      withChest: 'Mit {chest} cm Brustumfang gerechnet:', withHip: 'Mit {hip} cm Hüftumfang gerechnet:', withUsual: 'Deine übliche Größe {usual} habe ich einbezogen:',
      why: {
        oversized: 'Mit {ease} cm Weite über der Brust sitzt {size} so locker, wie der Schnitt gedacht ist.',
        tighter: 'Mit {ease} cm Weite sitzt {size} etwas weniger oversized als vorgesehen.',
        looser: 'Mit {ease} cm Weite fällt {size} extra weit aus.',
        regular: 'Mit {ease} cm Weite über der Brust sitzt {size} bequem, ohne weit zu sein.',
        usual: 'Oversized-Schnitte sind auf deine normale Größe ausgelegt – nimm {size}.',
        usualTight: 'Für einen kompakteren Sitz eine Größe kleiner als gewohnt: {size}.',
        usualLoose: 'Für extra Weite eine Größe größer als gewohnt: {size}.',
        bottom: '{size} passt zu deinem Hüftumfang; der elastische Bund mit Kordel gleicht die Taille aus.',
        bottomLoose: '{size} passt zu deinem Taillenumfang; der Bund ist elastisch.',
        jacket: 'Dein Brustumfang liegt im Bereich von {size}.',
        kids: '{size} ist für {range} cm Körpergröße gemacht.', kidsGrow: 'Zwischen zwei Größen – {size} lässt Platz zum Reinwachsen.',
        baby: '{size} Monate passt zu diesem Alter.', hat: '{size} ist für bis zu {head} cm Kopfumfang gedacht.'
      },
      lenOk: 'Die Länge von {len} cm passt zu deiner Größe.', lenShort: 'Mit {len} cm fällt es an dir eher kurz aus.', lenLong: 'Mit {len} cm fällt es an dir eher lang aus.',
      altTight: 'Alternative: {alt} sitzt etwas körpernäher.', altLoose: 'Alternative: {alt} sitzt etwas weiter.', betweenTight: 'Du liegst zwischen zwei Größen – {alt} sitzt etwas körpernäher.', betweenLoose: 'Du liegst zwischen zwei Größen – {alt} sitzt etwas weiter.',
      edgeBig: 'Das ist die größte verfügbare Größe – sie könnte für dich enger ausfallen als gedacht.',
      edgeSmall: 'Das ist die kleinste verfügbare Größe – sie könnte weiter ausfallen.',
      estNote: 'Dein Brustumfang ist aus Größe und Gewicht geschätzt. Mit dem gemessenen Wert wird es genauer.',
      estNoteHip: 'Dein Hüftumfang ist aus Größe und Gewicht geschätzt. Mit dem gemessenen Wert wird es genauer.',
      conf: ['Sehr gute Übereinstimmung', 'Gute Übereinstimmung', 'Zwischen zwei Größen'],
      chestRow: 'Brust', lengthRow: 'Länge', hipRow: 'Hüfte', waistRow: 'Bund', inseamRow: 'Innenbein', garment: 'Artikel', you: 'Du',
      zones: ['körpernah', 'wie gedacht', 'weit'], elastic: 'elastisch',
      choose: 'Größe {size} auswählen', chosen: 'Größe {size} ist ausgewählt – du kannst das Fenster schließen.', unavailable: '{size} ist in dieser Farbe gerade ausverkauft.',
      cChest: 'Brustumfang angeben', cHip: 'Hüftumfang angeben', cUsual: 'Übliche Größe angeben', cChart: 'Maßtabelle', cRestart: 'Von vorn', cFit: 'Passform ändern',
      outRange: 'Das passt nicht ganz – bitte prüf die Zahl noch einmal.', noInput: 'Das habe ich nicht verstanden. Du kannst mir Größe und Gewicht, deinen Brustumfang oder deine übliche Größe schreiben.',
      explain: 'Ich vergleiche die flach gemessene Brustweite des Artikels (mal zwei) mit deinem Brustumfang. Die Differenz ist die Weite – bei Oversized-Schnitten sind etwa {ease} cm vorgesehen, ich suche die Größe, die dem am nächsten kommt.',
      thanks: 'Gern! Wenn du magst, wähle die Größe direkt aus.',
      source: 'Grundlage: {src}, Toleranz ±{tol} cm.', sourceNoTol: 'Grundlage: {src}.',
      kidsSize: 'Größe', months: 'Monate', chipsHint: 'Antworte unten oder tippe.', placeholder: 'z. B. 183 cm, 86 kg',
      placeholderKids: 'z. B. 116 cm', placeholderBaby: 'z. B. 6 Monate', placeholderHead: 'z. B. 58 cm', placeholderChest: 'z. B. 104 cm', placeholderUsual: 'z. B. L', placeholderResult: 'z. B. „Brust 104“ oder „sonst L“'
    },
    en: {
      hiProduct: 'Hi! I’ll find your size for “{name}” – based on this item’s actual measurements. How tall are you and how much do you weigh?',
      hiPage: 'Hi! I’ll find your size based on the actual garment measurements. Which item are you looking at?',
      askBody: 'How tall are you and how much do you weigh? For example “183 cm, 86 kg”.',
      askBodyShort: 'I still need {what}.', heightWord: 'your height', weightWord: 'your weight',
      back: 'Welcome back. I still have your details: {summary}. Shall I use them for “{name}”?',
      hiShort: 'Hi! I’ll find the right size for “{name}”.',
      backYes: 'Yes, use them', backNo: 'Enter again',
      gotBody: '{h} cm and {w} kg, thanks.', askFit: 'How should it fit?',
      fitO: ['Less oversized', 'Oversized as designed', 'Extra roomy'], fitR: ['Close', 'Regular', 'Relaxed'],
      askKids: 'How tall is the child right now? In cm, please.', askBaby: 'How old is the baby? In months, please.', askHead: 'What is your head circumference in cm? Measure across forehead and back of head.',
      askChest: 'Wrap the tape loosely under your arms around the fullest part of your chest. How many cm?',
      askHip: 'Measure around the fullest part of your hips. How many cm?',
      askUsual: 'Which size do you usually wear, e.g. in T-shirts of other brands?',
      onlyUsual: 'I only know my usual size',
      rec: 'My recommendation: {size}.', recSame: 'Still {size}.', recNew: 'Now {size} instead of {old}.',
      withChest: 'Calculated with a {chest} cm chest:', withHip: 'Calculated with {hip} cm hips:', withUsual: 'I included your usual size {usual}:',
      why: {
        oversized: 'With {ease} cm of ease at the chest, {size} sits as loose as the cut is designed to.',
        tighter: 'With {ease} cm of ease, {size} fits slightly less oversized than intended.',
        looser: 'With {ease} cm of ease, {size} fits extra roomy.',
        regular: 'With {ease} cm of ease at the chest, {size} is comfortable without being loose.',
        usual: 'Oversized cuts are designed for your usual size – take {size}.',
        usualTight: 'For a more compact fit, one size down from usual: {size}.',
        usualLoose: 'For extra room, one size up from usual: {size}.',
        bottom: '{size} matches your hips; the elastic drawstring waist adjusts to your waist.',
        bottomLoose: '{size} matches your waist; the waistband is elastic.',
        jacket: 'Your chest falls within the {size} range.',
        kids: '{size} is made for {range} cm height.', kidsGrow: 'Between two sizes – {size} leaves room to grow.',
        baby: '{size} months fits this age.', hat: '{size} is designed for up to {head} cm head circumference.'
      },
      lenOk: 'The length of {len} cm suits your height.', lenShort: 'At {len} cm it will run on the short side for you.', lenLong: 'At {len} cm it will run on the long side for you.',
      altTight: 'Alternative: {alt} sits a little closer.', altLoose: 'Alternative: {alt} sits a little roomier.', betweenTight: 'You are between two sizes – {alt} sits a little closer.', betweenLoose: 'You are between two sizes – {alt} sits a little roomier.',
      edgeBig: 'This is the largest size available – it may fit tighter than intended.',
      edgeSmall: 'This is the smallest size available – it may fit roomier.',
      estNote: 'Your chest is estimated from height and weight. A measured value makes it more precise.',
      estNoteHip: 'Your hips are estimated from height and weight. A measured value makes it more precise.',
      conf: ['Excellent match', 'Good match', 'Between two sizes'],
      chestRow: 'Chest', lengthRow: 'Length', hipRow: 'Hips', waistRow: 'Waistband', inseamRow: 'Inseam', garment: 'Item', you: 'You',
      zones: ['close', 'as designed', 'roomy'], elastic: 'elastic',
      choose: 'Select size {size}', chosen: 'Size {size} is selected – you can close this window.', unavailable: '{size} is currently sold out in this colour.',
      cChest: 'Enter chest', cHip: 'Enter hips', cUsual: 'Enter usual size', cChart: 'Size chart', cRestart: 'Start over', cFit: 'Change fit',
      outRange: 'That doesn’t look right – please check the number.', noInput: 'I didn’t get that. You can tell me height and weight, your chest measurement or your usual size.',
      explain: 'I compare the item’s flat chest width (times two) with your chest circumference. The difference is the ease – oversized cuts are designed for about {ease} cm, and I pick the size closest to that.',
      thanks: 'You’re welcome! Select the size directly if you like.',
      source: 'Based on: {src}, tolerance ±{tol} cm.', sourceNoTol: 'Based on: {src}.',
      kidsSize: 'Size', months: 'months', chipsHint: 'Answer below or type.', placeholder: 'e.g. 183 cm, 86 kg',
      placeholderKids: 'e.g. 116 cm', placeholderBaby: 'e.g. 6 months', placeholderHead: 'e.g. 58 cm', placeholderChest: 'e.g. 104 cm', placeholderUsual: 'e.g. L', placeholderResult: 'e.g. “chest 104” or “usually L”'
    },
    tr: {
      hiProduct: 'Merhaba! „{name}“ için bedenini gerçek ürün ölçülerine göre buluyorum. Boyun ve kilon kaç?',
      hiPage: 'Merhaba! Bedenini gerçek ürün ölçülerine göre buluyorum. Hangi ürün için bakıyorsun?',
      askBody: 'Boyun ve kilon kaç? Örneğin „183 cm, 86 kg“.',
      askBodyShort: 'Bir de {what} lazım.', heightWord: 'boyun', weightWord: 'kilon',
      back: 'Tekrar hoş geldin. Bilgilerin bende: {summary}. „{name}“ için bunlarla hesaplayayım mı?',
      hiShort: 'Merhaba! „{name}“ için doğru bedeni buluyorum.',
      backYes: 'Evet, bunlarla', backNo: 'Yeniden gir',
      gotBody: '{h} cm ve {w} kg, teşekkürler.', askFit: 'Nasıl otursun?',
      fitO: ['Daha az oversize', 'Tasarlandığı gibi oversize', 'Ekstra bol'], fitR: ['Vücuda yakın', 'Normal', 'Rahat'],
      askKids: 'Çocuğun şu anki boyu kaç cm?', askBaby: 'Bebek kaç aylık?', askHead: 'Baş çevren kaç cm? Mezurayı alın ve ense üzerinden geçir.',
      askChest: 'Mezurayı kolların altından göğsün en geniş yerine gevşekçe sar. Kaç cm?',
      askHip: 'Kalçanın en geniş yerini ölç. Kaç cm?',
      askUsual: 'Normalde hangi bedeni giyersin, örneğin başka markaların tişörtlerinde?',
      onlyUsual: 'Sadece normal bedenimi biliyorum',
      rec: 'Önerim: {size}.', recSame: '{size} olarak kalıyor.', recNew: 'Artık {old} yerine {size}.',
      withChest: '{chest} cm göğüs çevresiyle hesaplandı:', withHip: '{hip} cm kalça çevresiyle hesaplandı:', withUsual: 'Normal bedenin {usual} dahil edildi:',
      why: {
        oversized: '{size}, göğüste {ease} cm bollukla kalıbın tasarlandığı gibi rahat oturur.',
        tighter: '{size}, {ease} cm bollukla biraz daha az oversize oturur.',
        looser: '{size}, {ease} cm bollukla ekstra bol oturur.',
        regular: '{size}, göğüste {ease} cm bollukla rahat ama bol değil.',
        usual: 'Oversize kalıplar normal bedenine göre tasarlanır – {size} al.',
        usualTight: 'Daha dar durması için normalden bir beden küçük: {size}.',
        usualLoose: 'Ekstra bolluk için normalden bir beden büyük: {size}.',
        bottom: '{size} kalça ölçüne uyar; lastikli bağcıklı bel uyum sağlar.',
        bottomLoose: '{size} bel ölçüne uyar; bel lastiklidir.',
        jacket: 'Göğüs çevren {size} aralığında.',
        kids: '{size}, {range} cm boy için.', kidsGrow: 'İki beden arasında – {size} büyümeye pay bırakır.',
        baby: '{size} ay bu yaşa uygundur.', hat: '{size}, {head} cm baş çevresine kadar.'
      },
      lenOk: '{len} cm boy ölçüsü boyuna uygun.', lenShort: '{len} cm ile sende biraz kısa durur.', lenLong: '{len} cm ile sende biraz uzun durur.',
      altTight: 'Alternatif: {alt} biraz daha dar oturur.', altLoose: 'Alternatif: {alt} biraz daha bol oturur.', betweenTight: 'İki beden arasındasın – {alt} biraz daha dar oturur.', betweenLoose: 'İki beden arasındasın – {alt} biraz daha bol oturur.',
      edgeBig: 'Bu mevcut en büyük beden – beklenenden dar gelebilir.',
      edgeSmall: 'Bu mevcut en küçük beden – bol gelebilir.',
      estNote: 'Göğüs çevren boy ve kilodan tahmin edildi. Ölçülmüş değerle daha kesin olur.',
      estNoteHip: 'Kalça çevren boy ve kilodan tahmin edildi. Ölçülmüş değerle daha kesin olur.',
      conf: ['Çok iyi uyum', 'İyi uyum', 'İki beden arasında'],
      chestRow: 'Göğüs', lengthRow: 'Boy', hipRow: 'Kalça', waistRow: 'Bel', inseamRow: 'İç bacak', garment: 'Ürün', you: 'Sen',
      zones: ['vücuda yakın', 'tasarlandığı gibi', 'bol'], elastic: 'lastikli',
      choose: '{size} bedeni seç', chosen: '{size} beden seçildi – pencereyi kapatabilirsin.', unavailable: '{size} bu renkte şu an tükendi.',
      cChest: 'Göğüs çevresi gir', cHip: 'Kalça çevresi gir', cUsual: 'Normal bedenini gir', cChart: 'Beden tablosu', cRestart: 'Baştan', cFit: 'Kalıbı değiştir',
      outRange: 'Bu pek uymuyor – sayıyı bir daha kontrol et.', noInput: 'Anlayamadım. Boy ve kilonu, göğüs çevreni veya normal bedenini yazabilirsin.',
      explain: 'Ürünün düz ölçülen göğüs enini (iki katı) göğüs çevrenle karşılaştırıyorum. Fark bolluktur – oversize kalıplarda yaklaşık {ease} cm öngörülür, buna en yakın bedeni seçerim.',
      thanks: 'Rica ederim! İstersen bedeni doğrudan seç.',
      source: 'Kaynak: {src}, tolerans ±{tol} cm.', sourceNoTol: 'Kaynak: {src}.',
      kidsSize: 'Beden', months: 'ay', chipsHint: 'Aşağıdan cevapla veya yaz.', placeholder: 'örn. 183 cm, 86 kg',
      placeholderKids: 'örn. 116 cm', placeholderBaby: 'örn. 6 ay', placeholderHead: 'örn. 58 cm', placeholderChest: 'örn. 104 cm', placeholderUsual: 'örn. L', placeholderResult: 'örn. „göğüs 104“ veya „normal L“'
    }
  };
  T.fr = T.en; T.nl = T.en;

  /* ---------- Hilfen ---------- */
  function num(v) { if (v == null) return null; var n = Number(String(v).trim().replace(',', '.')); return isFinite(n) && String(v).trim() !== '' ? n : null; }
  function fmt(n, lang) { var r = Math.round(n * 10) / 10; var s = String(r); return lang === 'en' ? s : s.replace('.', ','); }
  function tpl(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function canon(s) { s = String(s || '').trim().toUpperCase().replace(/\s+/g, ''); if (s === '2XL') return 'XXL'; if (s === 'XXXL') return '3XL'; return s; }
  function canonKids(s) { return String(s || '').split('(')[0].trim().replace(/\s+/g, ''); }
  function canonBaby(s) { var m = String(s || '').match(/(\d+)\s*[\/–-]\s*(\d+)/); return m ? m[1] + '/' + m[2] : String(s || '').trim(); }
  function load() { try { return JSON.parse(window.localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(p) { try { window.localStorage.setItem(STORE_KEY, JSON.stringify(p)); } catch (e) { /* ignore */ } }
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }
  function sizeStep(a, b) { var i = ORDER.indexOf(a), j = ORDER.indexOf(b); return (i < 0 || j < 0) ? 0 : (i - j); }

  /* ---------- Körpermaß-Schätzung (Erwachsene) ---------- */
  function estChest(h, w) { return clamp(52 + 0.6 * w - 0.1 * (h - 178), 70, 165); }
  function estWaist(h, w) { return clamp(31 + 0.73 * w - 0.1 * (h - 178), 58, 170); }
  function estHip(h, w) { return clamp(62 + 0.5 * w - 0.05 * (h - 178), 78, 170); }

  /* ---------- Konfektionsgrößen (Körperumfang-Mitten, cm) ---------- */
  var STD_MID = { XXS: 82, XS: 86, S: 92, M: 100, L: 108, XL: 116, XXL: 124, '3XL': 132, '4XL': 140, '5XL': 148 };
  var PREF_OFF = { oversized: [-6, 0, 6], relaxed: [-6, 0, 6], loose: [-6, 0, 6], regular: [-4, 2, 8] };
  function designedEase(chart, i, metric) {
    var mid = STD_MID[chart.sizes[i]]; if (mid == null) return null;
    if (metric === 'waist') mid -= 12;
    var g = chart[metric][i] * 2; return g - mid;
  }

  /* ---------- Berechnung ---------- */
  function compute(kind, chart, sizes, p) {
    var g = chart.group, idxs = [];
    chart.sizes.forEach(function (s, i) { if (sizes.indexOf(s) > -1) idxs.push(i); });
    if (!idxs.length) return null;
    var pref = p.fit == null ? 1 : Number(p.fit);

    if (g === 'kids') {
      var hk = num(p.childHeight); if (hk == null) return { need: 'kids' };
      if (hk < 80 || hk > 180) return { error: 'range' };
      var pick = null, grow = false;
      for (var a = 0; a < idxs.length; a++) { var r = chart.height[idxs[a]]; if (hk <= r[1]) { pick = idxs[a]; grow = hk < r[0]; break; } }
      var edge = null; if (pick == null) { pick = idxs[idxs.length - 1]; edge = 'big'; }
      return { size: chart.sizes[pick], idx: pick, kind: kind, why: grow ? 'kidsGrow' : 'kids', range: chart.height[pick].join('–'), conf: grow ? 2 : 0, edge: edge,
        rows: [{ k: 'chestRow', g: chart.chest[pick] * 2 }, { k: 'lengthRow', g: chart.length[pick] }] };
    }
    if (g === 'baby') {
      var m = num(p.babyAge); if (m == null) return { need: 'baby' };
      if (m < 0 || m > 30) return { error: 'range' };
      var pk = null;
      for (var b = 0; b < idxs.length; b++) { if (m < chart.months[idxs[b]][1] || b === idxs.length - 1) { pk = idxs[b]; break; } }
      return { size: chart.sizes[pk], idx: pk, kind: kind, why: 'baby', conf: m > 18 ? 2 : 0, edge: m > 18 ? 'big' : null, rows: [{ k: 'chestRow', g: chart.chest[pk] * 2 }] };
    }
    if (g === 'hat') {
      var hd = num(p.head); if (hd == null) return { need: 'hat' };
      if (hd < 48 || hd > 66) return { error: 'range' };
      var hi = hd <= 58 ? 0 : 1; if (idxs.indexOf(hi) < 0) hi = idxs[0];
      return { size: chart.sizes[hi], idx: hi, kind: kind, why: 'hat', headMax: chart.head[hi], conf: (hd > 57.5 && hd <= 58.5) ? 2 : 0, edge: hd > 61 ? 'big' : null, rows: [] };
    }

    var h = num(p.height), w = num(p.weight), chestIn = num(p.chest), hipIn = num(p.hip);
    if (h != null && (h < 140 || h > 215)) return { error: 'range' };
    if (w != null && (w < 38 || w > 200)) return { error: 'range' };
    if (chestIn != null && (chestIn < 70 || chestIn > 170)) return { error: 'range' };
    if (hipIn != null && (hipIn < 75 || hipIn > 175)) return { error: 'range' };
    var usual = p.usual ? canon(p.usual) : '';
    var haveBody = (h != null && w != null) || (g !== 'bottom' && chestIn != null) || (g === 'bottom' && hipIn != null && chart.hip);
    if (!haveBody && !usual) return { need: 'adult' };

    var bodyChest = chestIn != null ? chestIn : (h != null && w != null ? estChest(h, w) : null);
    var bodyWaist = (h != null && w != null) ? estWaist(h, w) : null;
    var bodyHip = hipIn != null ? hipIn : (h != null && w != null ? estHip(h, w) : null);
    var estimated = (g === 'bottom' ? hipIn == null : chestIn == null) && h != null && w != null;

    if (!haveBody) {
      var ui = chart.sizes.indexOf(usual);
      if (ui < 0 || idxs.indexOf(ui) < 0) {
        var best = idxs[0], bd = 99;
        idxs.forEach(function (i) { var d = Math.abs(sizeStep(chart.sizes[i], usual)); if (d < bd) { bd = d; best = i; } });
        ui = best;
      }
      var whyU = 'usual';
      if (pref === 0 && idxs.indexOf(ui - 1) > -1) { ui = ui - 1; whyU = 'usualTight'; }
      if (pref === 2 && idxs.indexOf(ui + 1) > -1) { ui = ui + 1; whyU = 'usualLoose'; }
      return { size: chart.sizes[ui], idx: ui, kind: kind, why: whyU, conf: 1, usualOnly: true, rows: rowsFor(chart, ui, null, null, null, h) };
    }

    var off = PREF_OFF[chart.cut] || PREF_OFF.oversized;
    var scored = idxs.map(function (i) {
      var s = 0, ease = null, lenDev = null, designed = null;
      if (g === 'top') {
        ease = chart.chest[i] * 2 - bodyChest; designed = designedEase(chart, i, 'chest');
        s += Math.abs(ease - (designed + off[pref])) / 3;
        if (h != null && chart.length) { lenDev = chart.length[i] - h * chart.lenRatio; s += Math.max(0, Math.abs(lenDev) - 3) / 2.5; }
      } else if (g === 'jacket') {
        var rr = chart.bodyChest[i], target = bodyChest + (pref === 0 ? -1.5 : pref === 2 ? 3 : 0);
        s += target < rr[0] ? (rr[0] - target) / 3 : target > rr[1] ? (target - rr[1]) / 3 : 0;
        s += Math.abs(target - (rr[0] + rr[1]) / 2) / 12;
      } else if (g === 'bottom') {
        if (chart.hip && bodyHip != null) {
          ease = chart.hip[i] * 2 - bodyHip; designed = designedEase(chart, i, 'hip');
          s += Math.abs(ease - (designed + off[pref])) / 3;
          if (bodyWaist != null) { var wr = chart.waist[i] * 2; if (wr > bodyWaist + 4) s += (wr - bodyWaist - 4) / 4; }
        } else if (bodyWaist != null) {
          ease = chart.waist[i] * 2 - bodyWaist; designed = designedEase(chart, i, 'waist');
          s += Math.abs(ease - (designed + off[pref])) / 3;
        }
        if (h != null && chart.inseam) { var inseamBody = h * 0.455; lenDev = chart.inseam[i] - inseamBody; s += Math.max(0, -lenDev - 5) / 3 + Math.max(0, lenDev - 6) / 4; }
      }
      if (usual) s += Math.abs(sizeStep(chart.sizes[i], usual)) * 0.8;
      return { i: i, s: s, ease: ease, lenDev: lenDev, designed: designed };
    });
    scored.sort(function (a, b) { return a.s - b.s; });
    var top = scored[0], second = scored[1];
    var conf = 0;
    if (second && second.s - top.s < 0.6) conf = 2; else if (top.s > 1.5 || (second && second.s - top.s < 1.6)) conf = 1;
    var edge2 = null;
    if (top.ease != null && top.designed != null && g !== 'jacket') {
      var tgt = top.designed + off[pref];
      if (top.i === idxs[idxs.length - 1] && top.ease < tgt - 6) edge2 = 'big';
      if (top.i === idxs[0] && top.ease > tgt + 8) edge2 = 'small';
    }
    if (g === 'jacket') {
      if (top.i === idxs[idxs.length - 1] && bodyChest > chart.bodyChest[top.i][1] + 2) edge2 = 'big';
      if (top.i === idxs[0] && bodyChest < chart.bodyChest[top.i][0] - 3) edge2 = 'small';
    }
    var alt = null;
    if (second && Math.abs(second.i - top.i) === 1 && second.s - top.s < 1.6) alt = { size: chart.sizes[second.i], dir: second.i < top.i ? 'tighter' : 'looser' };
    var why = g === 'jacket' ? 'jacket' : g === 'bottom' ? (chart.hip ? 'bottom' : 'bottomLoose') : 'oversized';
    if (g === 'top') {
      if (chart.cut === 'regular') why = 'regular';
      else { var dev = top.ease - top.designed; why = dev < -4 ? 'tighter' : dev > 4 ? 'looser' : 'oversized'; }
    }
    return { size: chart.sizes[top.i], idx: top.i, kind: kind, conf: conf, alt: alt, edge: edge2, why: why, ease: top.ease, designed: top.designed, lenDev: top.lenDev, estimated: estimated, pref: pref,
      rows: rowsFor(chart, top.i, bodyChest, bodyHip, bodyWaist, h) };
  }
  function rowsFor(chart, i, bodyChest, bodyHip, bodyWaist, h) {
    var rows = [];
    if (chart.group === 'top') {
      rows.push({ k: 'chestRow', g: chart.chest[i] * 2, b: bodyChest });
      if (chart.length) rows.push({ k: 'lengthRow', g: chart.length[i], ideal: h != null ? h * chart.lenRatio : null });
    } else if (chart.group === 'jacket') {
      rows.push({ k: 'chestRow', range: chart.bodyChest[i], b: bodyChest });
    } else if (chart.group === 'bottom') {
      if (chart.hip) rows.push({ k: 'hipRow', g: chart.hip[i] * 2, b: bodyHip });
      rows.push({ k: 'waistRow', g: chart.waist[i] * 2, b: chart.hip ? null : bodyWaist, elastic: true });
      if (chart.inseam) rows.push({ k: 'inseamRow', g: chart.inseam[i], ideal: h != null ? h * 0.455 : null });
    }
    return rows;
  }

  /* ---------- Eingabe verstehen ---------- */
  function parseInput(text, ctx) {
    var t = String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
    var out = {};
    if (!t) return out;
    if (/\b(neu|von vorn|restart|reset|nochmal|baştan|yeniden)\b/.test(t)) out.intent = 'restart';
    else if (/(tabelle|maßtabelle|masstabelle|chart|table|tablo)/.test(t)) out.intent = 'chart';
    else if (/(warum|wieso|weshalb|why|how|erklär|neden|nasıl)/.test(t)) out.intent = 'why';
    else if (/^(danke|dankeschön|thanks|thank you|merci|teşekkürler|sağol|ok|okay|top|super|perfekt)[.! ]*$/.test(t)) out.intent = 'thanks';
    var m;
    if ((m = t.match(/(brust|chest|göğüs|gogus|poitrine|borst)[^\d]{0,14}(\d{2,3}(?:[.,]\d)?)/))) out.chest = Number(m[2].replace(',', '.'));
    if ((m = t.match(/(hüfte|huefte|hip|kalça|kalca|hanche|heup)[^\d]{0,14}(\d{2,3}(?:[.,]\d)?)/))) out.hip = Number(m[2].replace(',', '.'));
    if ((m = t.match(/(kopf|head|baş|bas çevresi|tête|hoofd)[^\d]{0,14}(\d{2}(?:[.,]\d)?)/))) out.head = Number(m[2].replace(',', '.'));
    if ((m = t.match(/(\d)[.,](\d{2})\s*m\b/))) out.height = Number(m[1]) * 100 + Number(m[2]);
    if ((m = t.match(/(\d{3})\s*cm/))) out.height = Number(m[1]);
    if ((m = t.match(/(\d{2,3}(?:[.,]\d)?)\s*(kg|kilo)/))) out.weight = Number(m[1].replace(',', '.'));
    if ((m = t.match(/(\d{1,2})\s*(monat|monate|months?|ay\b|mois|maand)/))) out.babyAge = Number(m[1]);
    if (/^(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|5xl)$/.test(t)) out.usual = canon(t);
    else if ((m = t.match(/(größe|groesse|grösse|size|trage|sonst|normal|üblich|beden|taille|maat)\D{0,16}\b(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|5xl)\b/))) out.usual = canon(m[2]);
    if (/(enger|kleiner|weniger oversized|schmaler|körpernah|koerpernah|tight|closer|smaller|dar|daha az)/.test(t)) out.fit = 0;
    else if (/(weiter|größer|groesser|lockerer|extra weit|bigger|looser|roomier|relaxed|bol)/.test(t)) out.fit = 2;
    else if (/(wie gedacht|normal|standard|regular|as designed|tasarlandığı)/.test(t) && !out.usual) out.fit = 1;
    // nackte Zahlen
    var bare = (t.replace(/\d[.,]\d{2}\s*m\b/g, ' ').match(/\d{1,3}(?:[.,]\d)?/g) || []).map(function (x) { return Number(x.replace(',', '.')); });
    var used = [];
    if (out.chest != null) used.push(out.chest); if (out.hip != null) used.push(out.hip); if (out.head != null) used.push(out.head);
    if (out.height != null) used.push(out.height); if (out.weight != null) used.push(out.weight); if (out.babyAge != null) used.push(out.babyAge);
    bare = bare.filter(function (n) { var k = used.indexOf(n); if (k > -1) { used.splice(k, 1); return false; } return true; });
    var expect = ctx.expect || 'body';
    if (expect === 'chest' && bare.length && out.chest == null && bare[0] >= 60 && bare[0] <= 180) out.chest = bare.shift();
    else if (expect === 'hip' && bare.length && out.hip == null && bare[0] >= 60 && bare[0] <= 180) out.hip = bare.shift();
    else if (expect === 'head' && bare.length && out.head == null && bare[0] >= 45 && bare[0] <= 70) out.head = bare.shift();
    else if (expect === 'kids' && bare.length && bare[0] >= 60 && bare[0] <= 190) out.childHeight = bare.shift();
    else if (expect === 'baby' && bare.length && out.babyAge == null && bare[0] >= 0 && bare[0] <= 40) out.babyAge = bare.shift();
    bare.forEach(function (n) {
      if (out.height == null && n >= 140 && n <= 215 && (out.weight != null || bare.length > 1 || n >= 150)) { out.height = n; return; }
      if (out.weight == null && n >= 38 && n <= 200) { out.weight = n; return; }
    });
    if (ctx.expect === 'kids' && out.childHeight == null && out.height != null && out.height <= 180) { out.childHeight = out.height; delete out.height; }
    return out;
  }

  /* ---------- Shop-Anbindung ---------- */
  function parseVariants(root) {
    var s = root.querySelector('[data-rs-variant-data]');
    try { var d = JSON.parse((s && s.textContent) || '[]'); return Array.isArray(d) ? d : []; } catch (e) { return []; }
  }
  function sizeLabelToChart(kind, label) {
    var g = CHARTS[kind].group;
    if (g === 'kids') return canonKids(label);
    if (g === 'baby') return canonBaby(label);
    if (g === 'hat') return String(label).trim().toUpperCase();
    return canon(label);
  }
  function productForm(root) {
    var id = root.getAttribute('data-rs-product-id');
    return document.querySelector('form[data-product-id="' + id + '"]') || document.querySelector('product-form form, form[action*="/cart/add"]');
  }
  function currentVariant(root, list) {
    var f = productForm(root), inp = f && f.querySelector('input[name="id"], select[name="id"]');
    var id = (inp && inp.value) || root.getAttribute('data-rs-active-id');
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return list[0] || null;
  }
  function sizeInfo(root, kind, isPage) {
    var list = isPage ? [] : parseVariants(root), idx = num(root.getAttribute('data-rs-size-index'));
    var chart = CHARTS[kind], out = { sizes: [], labels: {}, avail: {} };
    if (!list.length || idx == null) {
      var def = chart.sizes.slice();
      if (kind === 'oversize-t-shirt' || kind === 'oversize-hoodie') def = ['S', 'M', 'L', 'XL', 'XXL'];
      if (kind === 'regular-fit-t-shirt') def = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
      def.forEach(function (s) { out.sizes.push(s); out.labels[s] = s; out.avail[s] = true; });
      return out;
    }
    var cur = currentVariant(root, list);
    list.forEach(function (v) {
      var lab = v.options[idx], c = sizeLabelToChart(kind, lab);
      if (chart.sizes.indexOf(c) < 0) return;
      if (out.sizes.indexOf(c) < 0) { out.sizes.push(c); out.labels[c] = lab; out.avail[c] = false; }
      var same = true;
      if (cur) for (var k = 0; k < v.options.length; k++) { if (k !== idx && v.options[k] !== cur.options[k]) { same = false; break; } }
      if (same && v.available) out.avail[c] = true;
    });
    out.sizes.sort(function (a, b) { return chart.sizes.indexOf(a) - chart.sizes.indexOf(b); });
    return out;
  }
  function selectSize(label) {
    var fs = document.querySelectorAll('variant-picker fieldset, .option-selector');
    for (var i = 0; i < fs.length; i++) {
      var inputs = fs[i].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === label) { var lbl = document.querySelector('label[for="' + inputs[j].id + '"]'); if (lbl) lbl.click(); else inputs[j].click(); return true; }
      }
      var sel = fs[i].querySelector('select');
      if (sel) for (var o = 0; o < sel.options.length; o++) if (sel.options[o].value === label) { sel.value = label; sel.dispatchEvent(new Event('change', { bubbles: true })); return true; }
    }
    return false;
  }

  /* ---------- Chat ---------- */
  function initRoot(root) {
    if (root.__rsFitV9) return;
    root.__rsFitV9 = true;
    var lang = (root.getAttribute('data-rs-lang') || 'de').toLowerCase();
    var W = T[lang] || T.en;
    var isPage = root.getAttribute('data-rs-context') !== 'modal';
    var kind = root.getAttribute('data-rs-kind') || '';
    var productName = root.getAttribute('data-rs-product-name') || '';
    var thread = root.querySelector('[data-rs-thread]'), chips = root.querySelector('[data-rs-chips]');
    var form = root.querySelector('[data-rs-chat-form]'), input = root.querySelector('[data-rs-message]');
    if (!thread || !chips || !form || !input) return;
    if (!isPage && !CHARTS[kind]) { root.hidden = true; return; }

    var profile = load();
    var st = { step: 'start', expect: 'body', last: null, kindAsked: false };
    function name() { return (!isPage && productName) || KIND_NAMES[kind] || ''; }
    function chart() { return CHARTS[kind]; }

    function scroll() { try { thread.scrollTop = thread.scrollHeight; } catch (e) { /* ignore */ } }
    function bubble(role, content) {
      var m = el('div', 'rs-chat__msg rs-chat__msg--' + role);
      var c = el('div', 'rs-chat__bubble');
      if (typeof content === 'string') c.textContent = content; else c.appendChild(content);
      m.appendChild(c); thread.appendChild(m); scroll(); return c;
    }
    function say(text) { return bubble('assistant', text); }
    function setChips(items) {
      chips.innerHTML = '';
      items.forEach(function (it) {
        var b = el('button', 'rs-chat__chip' + (it.primary ? ' rs-chat__chip--primary' : ''), it.label); b.type = 'button';
        if (it.disabled) b.disabled = true;
        b.addEventListener('click', function () { if (b.disabled) return; if (!it.silent) bubble('user', it.label); chips.innerHTML = ''; it.run(); });
        chips.appendChild(b);
      });
    }
    function ask(step, text, items, expect, ph) {
      st.step = step; st.expect = expect || 'body';
      say(text); setChips(items || []);
      input.placeholder = ph || W.placeholder;
      if (!('ontouchstart' in window) && step !== 'done') { try { input.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
    function fitLabels() { var c = chart(); return (c.cut === 'oversized' || c.cut === 'relaxed' || c.cut === 'loose') ? W.fitO : W.fitR; }
    function bodySummary() {
      var parts = [];
      if (profile.height) parts.push(fmt(profile.height, lang) + ' cm'); if (profile.weight) parts.push(fmt(profile.weight, lang) + ' kg');
      if (profile.chest) parts.push(W.chestRow + ' ' + fmt(profile.chest, lang) + ' cm'); if (profile.usual) parts.push(W.kidsSize + ' ' + profile.usual);
      return parts.join(', ');
    }
    function kidsChips() {
      return KIND_ORDER.map(function (k) { return { label: KIND_NAMES[k], run: function () { kind = k; profile.kind = k; save(profile); syncCharts(); afterKind(); } }; });
    }

    /* Flow */
    function start() {
      thread.innerHTML = ''; chips.innerHTML = ''; st.last = null;
      if (isPage) { kind = ''; ask('kind', W.hiPage, kidsChips(), 'none', W.placeholder); return; }
      entry();
    }
    function entry() {
      var g = chart().group;
      if (g === 'kids') return ask('kids', tpl(W.hiShort, { name: name() }) + ' ' + W.askKids, [], 'kids', W.placeholderKids);
      if (g === 'baby') return ask('baby', tpl(W.hiShort, { name: name() }) + ' ' + W.askBaby, [], 'baby', W.placeholderBaby);
      if (g === 'hat') return ask('hat', tpl(W.hiShort, { name: name() }) + ' ' + W.askHead, [], 'head', W.placeholderHead);
      if (profile.height && profile.weight) {
        ask('back', tpl(W.back, { summary: bodySummary(), name: name() }), [
          { label: W.backYes, primary: true, run: function () { if (profile.fit == null) askFit(); else result(null); } },
          { label: W.backNo, run: function () { profile = { kind: profile.kind }; save(profile); ask('body', W.askBody, [{ label: W.onlyUsual, run: askUsual }], 'body', W.placeholder); } }
        ], 'body');
        return;
      }
      ask('body', tpl(W.hiProduct, { name: name() }), [{ label: W.onlyUsual, run: askUsual }], 'body', W.placeholder);
    }
    function afterKind() { entry(); }
    function askBody(again) {
      var g = chart().group;
      if (g === 'kids' || g === 'baby' || g === 'hat') return entry();
      ask('body', W.askBody, [{ label: W.onlyUsual, run: askUsual }], 'body', W.placeholder);
    }
    function askFit() {
      var labels = fitLabels();
      ask('fit', tpl(W.askFit, { name: name() }), labels.map(function (l, i) {
        return { label: l, primary: i === 1, run: function () { profile.fit = i; save(profile); result(null); } };
      }), 'fit');
    }
    function askUsual() {
      var sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
      ask('usual', W.askUsual, sizes.map(function (s) { return { label: s, run: function () { profile.usual = s; save(profile); if (profile.fit == null && !profile.height) askFit(); else result('usual'); } }; }), 'usual', W.placeholderUsual);
    }
    function askChest() { ask('chest', W.askChest, [], 'chest', W.placeholderChest); }
    function askHip() { ask('hip', W.askHip, [], 'hip', W.placeholderChest); }

    function result(reason) {
      var c = chart(), info = sizeInfo(root, kind, isPage);
      var res = compute(kind, c, info.sizes, profile);
      if (!res) { say(W.noInput); return; }
      if (res.error) { say(W.outRange); st.step = 'body'; return; }
      if (res.need) {
        if (res.need === 'kids') return ask('kids', W.askKids, [], 'kids', W.placeholderKids);
        if (res.need === 'baby') return ask('baby', W.askBaby, [], 'baby', W.placeholderBaby);
        if (res.need === 'hat') return ask('hat', W.askHead, [], 'head', W.placeholderHead);
        return askBody(true);
      }
      var shopLabel = info.labels[res.size] || res.size;
      var shown = c.group === 'baby' ? shopLabel.replace(/\s*(Monate?|months?|ay|mois|maanden)/i, '') : (c.group === 'kids' ? res.size : shopLabel);
      var lead = '';
      if (reason === 'chest' && profile.chest) lead = tpl(W.withChest, { chest: fmt(profile.chest, lang) }) + ' ';
      if (reason === 'hip' && profile.hip) lead = tpl(W.withHip, { hip: fmt(profile.hip, lang) }) + ' ';
      if (reason === 'usual' && profile.usual && profile.height) lead = tpl(W.withUsual, { usual: profile.usual }) + ' ';
      var head = st.last ? (st.last === res.size ? tpl(W.recSame, { size: shown }) : tpl(W.recNew, { size: shown, old: info.labels[st.last] || st.last })) : tpl(W.rec, { size: shown });
      var sentences = [lead + head];
      sentences.push(tpl(W.why[res.why] || '', { size: shown, ease: res.ease != null ? fmt(Math.round(res.ease), lang) : '', range: res.range || '', head: res.headMax || '' }));
      if (res.lenDev != null && c.group === 'top') { var L = c.length[res.idx]; sentences.push(tpl(res.lenDev < -3 ? W.lenShort : res.lenDev > 3 ? W.lenLong : W.lenOk, { len: fmt(L, lang) })); }
      if (res.alt) sentences.push(tpl(res.conf === 2 ? (res.alt.dir === 'tighter' ? W.betweenTight : W.betweenLoose) : (res.alt.dir === 'tighter' ? W.altTight : W.altLoose), { alt: info.labels[res.alt.size] || res.alt.size }));
      if (res.edge) sentences.push(res.edge === 'big' ? W.edgeBig : W.edgeSmall);
      var recBubble = say(sentences.filter(Boolean).join(' '));

      /* Karte */
      var card = el('div', 'rs-chat__card');
      var top = el('div', 'rs-chat__card-head');
      var left = el('div'); left.appendChild(el('span', 'rs-chat__conf rs-chat__conf--' + res.conf, W.conf[res.conf]));
      top.appendChild(left); top.appendChild(el('span', 'rs-chat__size', shown)); card.appendChild(top);
      if (res.ease != null && res.designed != null) {
        var lo = res.designed - 14, hi = res.designed + 14, pos = clamp((res.ease - lo) / (hi - lo), 0, 1);
        var meter = el('div', 'rs-chat__meter'); meter.setAttribute('aria-hidden', 'true');
        var bar = el('div', 'rs-chat__meter-bar');
        bar.style.setProperty('--z1', ((res.designed - 3 - lo) / (hi - lo) * 100).toFixed(1) + '%');
        bar.style.setProperty('--z2', ((res.designed + 3 - lo) / (hi - lo) * 100).toFixed(1) + '%');
        var dot = el('span', 'rs-chat__meter-dot'); dot.style.left = (pos * 100).toFixed(1) + '%'; bar.appendChild(dot); meter.appendChild(bar);
        var labs = el('div', 'rs-chat__meter-labels'); W.zones.forEach(function (z) { labs.appendChild(el('span', null, z)); }); meter.appendChild(labs);
        card.appendChild(meter);
      }
      if (res.rows && res.rows.length) {
        var rows = el('div', 'rs-chat__rows');
        res.rows.forEach(function (r) {
          var line = el('div', 'rs-chat__row'); line.appendChild(el('span', 'rs-chat__row-k', W[r.k]));
          var v = el('span', 'rs-chat__row-v'), txt;
          if (r.range) txt = W.garment + ' ' + r.range[0] + '–' + r.range[1] + ' cm' + (r.b != null ? ' · ' + W.you + ' ' + fmt(Math.round(r.b), lang) + ' cm' : '');
          else if (r.ideal != null) { var d = r.g - r.ideal; txt = fmt(r.g, lang) + ' cm · ' + (d < -3 ? W.zones[0] : d > 3 ? W.zones[2] : '✓'); if (d >= -3 && d <= 3) txt = fmt(r.g, lang) + ' cm ✓'; else txt = fmt(r.g, lang) + ' cm'; }
          else if (r.b != null) { var e = r.g - r.b; txt = W.garment + ' ' + fmt(r.g, lang) + ' · ' + W.you + ' ' + (res.estimated ? '≈ ' : '') + fmt(Math.round(r.b), lang) + ' · ' + (e >= 0 ? '+' : '') + fmt(Math.round(e), lang) + ' cm'; }
          else txt = fmt(r.g, lang) + ' cm' + (r.elastic ? ' · ' + W.elastic : '');
          v.textContent = txt; line.appendChild(v); rows.appendChild(line);
        });
        card.appendChild(rows);
      }
      if (res.estimated) card.appendChild(el('p', 'rs-chat__note', c.group === 'bottom' ? W.estNoteHip : W.estNote));
      var src = c.tol ? tpl(W.source, { src: c.src, tol: fmt(c.tol, lang) }) : tpl(W.sourceNoTol, { src: c.src });
      card.appendChild(el('p', 'rs-chat__src', src));
      bubble('assistant', card);
      try { thread.scrollTop = Math.max(0, recBubble.parentNode.offsetTop - thread.offsetTop - 6); } catch (e) { /* ignore */ }
      st.last = res.size; st.lastDesigned = res.designed;

      /* Vorschläge */
      var items = [];
      if (!isPage && root.querySelector('[data-rs-variant-data]')) {
        var avail = info.avail[res.size] !== false;
        items.push({ label: tpl(W.choose, { size: shopLabel }), primary: true, disabled: !avail, run: function () {
          if (selectSize(shopLabel)) {
            say(tpl(W.chosen, { size: shopLabel }));
            var modal = root.closest('modal-dialog'), close = modal && modal.querySelector('.js-close-modal');
            if (close) setTimeout(function () { close.click(); }, 700);
          } else say(W.noInput);
          setChips(afterChips());
        } });
        if (!avail) say(tpl(W.unavailable, { size: shopLabel }));
      }
      items = items.concat(afterChips());
      st.step = 'result'; st.expect = 'body'; input.placeholder = W.placeholderResult || W.placeholder;
      setChips(items);
    }
    function afterChips() {
      var c = chart(), g = c.group, items = [];
      if (g === 'top' || g === 'jacket') { if (!profile.chest) items.push({ label: W.cChest, run: askChest }); items.push({ label: W.cFit, run: askFit }); if (!profile.usual && g === 'top') items.push({ label: W.cUsual, run: askUsual }); }
      if (g === 'bottom') { if (c.hip && !profile.hip) items.push({ label: W.cHip, run: askHip }); items.push({ label: W.cFit, run: askFit }); }
      items.push({ label: W.cChart, run: openChart, silent: true });
      items.push({ label: W.cRestart, run: function () { profile = { kind: profile.kind }; save(profile); start(); } });
      return items;
    }

    /* Freitext */
    function handle(text) {
      var p = parseInput(text, { expect: st.expect });
      if (p.intent === 'restart') { profile = { kind: profile.kind }; save(profile); start(); return; }
      if (p.intent === 'chart') { openChart(); setChips(st.step === 'result' ? afterChips() : []); return; }
      if (p.intent === 'why' && st.step === 'result') { say(tpl(W.explain, { ease: st.lastDesigned != null ? fmt(Math.round(st.lastDesigned), lang) : 20 })); setChips(afterChips()); return; }
      if (p.intent === 'thanks') { say(W.thanks); setChips(st.step === 'result' ? afterChips() : []); return; }
      if (st.step === 'kind') {
        var hit = KIND_ORDER.filter(function (k) { return text.toLowerCase().indexOf(KIND_NAMES[k].toLowerCase().split(' ')[0]) > -1; });
        if (hit.length) { kind = hit[hit.length - 1]; profile.kind = kind; save(profile); syncCharts(); afterKind(); } else { say(W.noInput); setChips(kidsChips()); }
        return;
      }
      var changed = false;
      ['height', 'weight', 'chest', 'hip', 'head', 'childHeight', 'babyAge', 'usual', 'fit'].forEach(function (k) { if (p[k] != null) { profile[k] = p[k]; changed = true; } });
      if (!changed) { say(W.noInput); if (st.step === 'result') setChips(afterChips()); else if (st.step === 'body') setChips([{ label: W.onlyUsual, run: askUsual }]); return; }
      save(profile);
      var g = chart().group;
      if (g === 'kids' || g === 'baby' || g === 'hat') { result(null); return; }
      var hasBody = profile.height && profile.weight;
      if (st.step === 'result' || st.step === 'chest' || st.step === 'hip' || (st.step === 'usual' && hasBody)) {
        result(p.chest != null ? 'chest' : p.hip != null ? 'hip' : p.usual != null ? 'usual' : null); return;
      }
      if (p.usual != null && !hasBody && profile.fit == null) { askFit(); return; }
      if (p.usual != null && !hasBody) { result('usual'); return; }
      if (!hasBody && profile.chest == null) {
        var missing = !profile.height ? W.heightWord : W.weightWord;
        if (p.height != null || p.weight != null) ask('body', tpl(W.askBodyShort, { what: missing }), [{ label: W.onlyUsual, run: askUsual }], 'body', W.placeholder);
        else { say(W.noInput); setChips([{ label: W.onlyUsual, run: askUsual }]); }
        return;
      }
      if (hasBody && (p.height != null || p.weight != null)) say(tpl(W.gotBody, { h: fmt(profile.height, lang), w: fmt(profile.weight, lang) }));
      if (profile.fit == null) askFit(); else result(null);
    }

    function syncCharts() {
      var scope = root.closest('modal-dialog') || root.closest('.shopify-section') || document;
      var all = scope.querySelectorAll('[data-rs-chart]'); if (!all.length) all = document.querySelectorAll('[data-rs-chart]');
      [].forEach.call(all, function (c) { var match = c.getAttribute('data-rs-chart') === kind; if (!isPage) c.hidden = !match; if (match) c.open = true; });
    }
    function openChart() {
      syncCharts();
      var scope = root.closest('modal-dialog') || document, outer = scope.querySelector('[data-rs-size-details]') || document.querySelector('[data-rs-size-details]');
      if (outer && outer.tagName === 'DETAILS') outer.open = true;
      var target = scope.querySelector('[data-rs-chart="' + kind + '"]') || outer;
      if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault(); var v = String(input.value || '').trim(); if (!v) return; input.value = '';
      bubble('user', v); chips.innerHTML = '';
      try { handle(v); } catch (err) { say(W.noInput); }
    });
    var chartBtn = root.querySelector('[data-rs-open-measures]'); if (chartBtn) chartBtn.addEventListener('click', openChart);
    var resetBtn = root.querySelector('[data-rs-restart]'); if (resetBtn) resetBtn.addEventListener('click', function () { profile = { kind: profile.kind }; save(profile); start(); });

    if (!isPage) syncCharts();
    start();
    root.__rsFitRefresh = function () { if (st.step === 'result') { var cur = root.getAttribute('data-rs-kind'); if (cur && cur !== kind) { kind = cur; start(); } } };
  }

  function init() { [].forEach.call(document.querySelectorAll('[data-rs-fit]'), initRoot); }
  function refresh() { init(); [].forEach.call(document.querySelectorAll('[data-rs-fit]'), function (r) { if (r.__rsFitRefresh) r.__rsFitRefresh(); }); }

  window.__rsFitV9 = { init: init, compute: compute, parse: parseInput, charts: CHARTS, estChest: estChest, estHip: estHip, estWaist: estWaist };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('on:variant:change', function () { setTimeout(refresh, 60); });
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function (recs) {
      if (pending) return;
      for (var i = 0; i < recs.length; i++) if (recs[i].addedNodes && recs[i].addedNodes.length) { pending = true; break; }
      if (pending) (window.requestAnimationFrame || setTimeout)(function () { pending = false; init(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
